/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getICD10Diagnoses } from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './chronic-condition.reducer';

export const ChronicConditionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const iCD10Diagnoses = useAppSelector(state => state.iCD10Diagnosis.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const chronicConditionEntity = useAppSelector(state => state.chronicCondition.entity);
  const loading = useAppSelector(state => state.chronicCondition.loading);
  const updating = useAppSelector(state => state.chronicCondition.updating);
  const updateSuccess = useAppSelector(state => state.chronicCondition.updateSuccess);

  const handleClose = () => {
    navigate(`/chronic-condition${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getICD10Diagnoses({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.topographyStart !== undefined && typeof values.topographyStart !== 'number') {
      values.topographyStart = Number(values.topographyStart);
    }
    if (values.topographyEnd !== undefined && typeof values.topographyEnd !== 'number') {
      values.topographyEnd = Number(values.topographyEnd);
    }

    const entity = {
      ...chronicConditionEntity,
      ...values,
      diagnosis: iCD10Diagnoses.find(it => it.id.toString() === values.diagnosis?.toString()),
      topography: clinicalDictionaries.find(it => it.id.toString() === values.topography?.toString()),
      morphologyGroup: clinicalDictionaries.find(it => it.id.toString() === values.morphologyGroup?.toString()),
      morphology: clinicalDictionaries.find(it => it.id.toString() === values.morphology?.toString()),
      behaviour: clinicalDictionaries.find(it => it.id.toString() === values.behaviour?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...chronicConditionEntity,
          diagnosis: chronicConditionEntity?.diagnosis?.id,
          topography: chronicConditionEntity?.topography?.id,
          morphologyGroup: chronicConditionEntity?.morphologyGroup?.id,
          morphology: chronicConditionEntity?.morphology?.id,
          behaviour: chronicConditionEntity?.behaviour?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.chronicCondition.home.createOrEditLabel" data-cy="ChronicConditionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.chronicCondition.home.createOrEditLabel">Create or edit a ChronicCondition</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="chronic-condition-id"
                  label={translate('tinyMedicRestApp.chronicCondition.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.category')}
                id="chronic-condition-category"
                name="category"
                data-cy="category"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.subCategory')}
                id="chronic-condition-subCategory"
                name="subCategory"
                data-cy="subCategory"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.active')}
                id="chronic-condition-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.microSec')}
                id="chronic-condition-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.lastupdated')}
                id="chronic-condition-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.timestampentry')}
                id="chronic-condition-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.cursor')}
                id="chronic-condition-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.snomedConceptId')}
                id="chronic-condition-snomedConceptId"
                name="snomedConceptId"
                data-cy="snomedConceptId"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.snomedConceptText')}
                id="chronic-condition-snomedConceptText"
                name="snomedConceptText"
                data-cy="snomedConceptText"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.topographyStart')}
                id="chronic-condition-topographyStart"
                name="topographyStart"
                data-cy="topographyStart"
                type="text"
              />
              <UncontrolledTooltip target="topographyStartLabel">
                <Translate contentKey="tinyMedicRestApp.chronicCondition.help.topographyStart" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.topographyEnd')}
                id="chronic-condition-topographyEnd"
                name="topographyEnd"
                data-cy="topographyEnd"
                type="text"
              />
              <UncontrolledTooltip target="topographyEndLabel">
                <Translate contentKey="tinyMedicRestApp.chronicCondition.help.topographyEnd" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.chronicCondition.std')}
                id="chronic-condition-std"
                name="std"
                data-cy="std"
                check
                type="checkbox"
              />
              <ValidatedField
                id="chronic-condition-diagnosis"
                name="diagnosis"
                data-cy="diagnosis"
                label={translate('tinyMedicRestApp.chronicCondition.diagnosis')}
                type="select"
              >
                <option value="" key="0" />
                {iCD10Diagnoses
                  ? iCD10Diagnoses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="chronic-condition-topography"
                name="topography"
                data-cy="topography"
                label={translate('tinyMedicRestApp.chronicCondition.topography')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="chronic-condition-morphologyGroup"
                name="morphologyGroup"
                data-cy="morphologyGroup"
                label={translate('tinyMedicRestApp.chronicCondition.morphologyGroup')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="chronic-condition-morphology"
                name="morphology"
                data-cy="morphology"
                label={translate('tinyMedicRestApp.chronicCondition.morphology')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="chronic-condition-behaviour"
                name="behaviour"
                data-cy="behaviour"
                label={translate('tinyMedicRestApp.chronicCondition.behaviour')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/chronic-condition" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ChronicConditionUpdate;
